import axios from 'axios';

const LANGUAGE_OPTIONS = [
  { label: 'English', code: 'eng_Latn' },
  { label: 'Hindi', code: 'hin_Deva' },
  { label: 'Telugu', code: 'tel_Telu' },
  { label: 'Tamil', code: 'tam_Taml' },
  { label: 'Kannada', code: 'kan_Knda' },
  { label: 'Malayalam', code: 'mal_Mlym' },
  { label: 'Marathi', code: 'mar_Deva' },
  { label: 'Bengali', code: 'ben_Beng' },
  { label: 'Gujarati', code: 'guj_Gujr' },
  { label: 'Punjabi', code: 'pan_Guru' },
  { label: 'Urdu', code: 'urd_Arab' },
  { label: 'Arabic', code: 'arb_Arab' },
  { label: 'Bahasa Malaysia', code: 'msa_Latn' },
  { label: 'Indonesian', code: 'ind_Latn' },
  { label: 'Filipino', code: 'fil_Latn' },
  { label: 'Spanish', code: 'spa_Latn' },
  { label: 'French', code: 'fra_Latn' },
  { label: 'German', code: 'deu_Latn' },
  { label: 'Chinese', code: 'zho_Hans' },
  { label: 'Japanese', code: 'jpn_Jpan' },
  { label: 'Korean', code: 'kor_Hang' },
  { label: 'Russian', code: 'rus_Cyrl' },
  { label: 'Portuguese', code: 'por_Latn' },
  { label: 'Italian', code: 'ita_Latn' },
  { label: 'Dutch', code: 'nld_Latn' },
  { label: 'Turkish', code: 'tur_Latn' },
  { label: 'Vietnamese', code: 'vie_Latn' },
  { label: 'Thai', code: 'tha_Thai' },
];

const translationCache = new Map();

function cacheKey(text, targetLang) {
  return `${targetLang}::${text}`;
}

export function getLanguageOptions() {
  return LANGUAGE_OPTIONS;
}

export function getLanguageLabel(code) {
  return LANGUAGE_OPTIONS.find((l) => l.code === code)?.label || code;
}

export function isEnglishCode(code) {
  return code === 'eng_Latn' || !code;
}

export async function translateText(text, targetLang) {
  if (!text || !targetLang || isEnglishCode(targetLang)) return text;
  const key = cacheKey(text, targetLang);
  if (translationCache.has(key)) return translationCache.get(key);
  const { data } = await axios.post('/api/translate', { text, target: targetLang });
  const translated = data?.translated || text;
  translationCache.set(key, translated);
  return translated;
}

export function clearTranslationCache() {
  translationCache.clear();
}
